// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.service-banner .sk-btn {\n  width: auto;\n  min-width: 190px;\n  margin-left: 20px;\n  padding: 0 15px;\n}\n@media (max-width: 650px) {\n.service-banner .sk-btn {\n    margin-top: 5px;\n    margin-left: 0;\n}\n}\n", ""]);
// Exports
module.exports = exports;
